//@ts-nocheck

import { service } from '@/ajax/request'
import { AxiosPromise } from 'axios'

export const getOpenTongueQr = (params: any = {}): AxiosPromise<any> => (
    service({
        url: `/ipad/diagnostics/getQrcode/${params.deviceCode}`,
        method: 'GET',
        params,
        type: "form",
        custom: true
    })
  )

export const checkQrcode = params =>
  service({
    url: `/ipad/diagnostics/bindingQrCodeUid/${params.qrCodeUid}`,
    method: "GET",
    params,
    type: "form",
    custom: true
  });

export const startDiagnostics = params =>
  service({
    url: `/ipad/diagnostics/startTongue`,
    method: "POST",
    params,
    headers: params.headers,
    type: "form"
  });

export const getTongueResult = params =>
  service({
    url: `/ipad/diagnostics/getTongueResult/${params.id}`,
    method: "GET",
    params,
    type: "form"
  });

export const getUserIdByTongueReportId = reportId => {
  return service({
    url: `/ipad/diagnostics/get-report-user-id/${reportId}`,
    method: "GET"
  });
};

export const getStoreTongueExpireCountAndNumber = params => {
  return service({
    url: `/device/tongue/getRemainData`,
    method: "GET",
    params,
    type: "form"
  });
};

export const getStoreTongueExpireCountAndNumberOld = params => {
  return service({
    url: `/device/tongue/getRemainData-old`,
    method: "GET",
    params,
    type: "form"
  });
};